module.exports = __webpack_public_path__ + "img/praia1.a4c85337.jpg";